import { Component } from '@angular/core';
import { GenerateUuidUsersFormComponent } from '../../../forms/standard/generate-uuid-users-form/generate-uuid-users-form.component';

@Component({
	selector: 'app-generate-uuid-users',
	standalone: true,
	imports: [GenerateUuidUsersFormComponent],
	templateUrl: './generate-uuid-users.component.html',
	styleUrl: './generate-uuid-users.component.scss',
})
export class GenerateUuidUsersComponent {}
